<span id="inputFields">
  <mat-form-field   appearance="fill" [ngClass]="{'full-width': forSalesOrder == true}">
    <mat-label>Name Description</mat-label>
    <input matInput autofocus (keyup.enter)="onEnter()" class="ta-customersearch-namedescription " [(ngModel)]="customerRequest.name"
      data-hj-whitelist id="nameField">
    <button class="mat-mdc-button-transparentBackground-BlackColor"  *ngIf="customerRequest.name" matSuffix mat-icon-button  aria-label="Clear"
      (click)="customerRequest.name=''" style="color: black !important;" >
      <mat-icon>close</mat-icon>
    </button>
    <mat-hint 
      *ngIf="(customerRequest.name == '' || customerRequest.name.length < 3 )">
      At least 3 characters </mat-hint>
  </mat-form-field>
  <mat-form-field appearance="fill" [ngClass]="{'full-width': forSalesOrder == true}">
    <mat-label>Name Id</mat-label>
    <input matInput (keyup.enter)="onEnter()" class="ta-customersearch-nameid" [(ngModel)]="customerRequest.nameId" data-hj-whitelist
      id="nameIdField">
    <button class="mat-mdc-button-transparentBackground-BlackColor"  *ngIf="customerRequest.nameId" matSuffix mat-icon-button aria-label="Clear"
      (click)="customerRequest.nameId=''" style="color: black !important;">
      <mat-icon>close</mat-icon>
    </button>
    <mat-hint 
      *ngIf="(customerRequest.nameId == '' || customerRequest.nameId.length < 3 )">
      At least 3 characters</mat-hint>
  </mat-form-field>
  <mat-form-field appearance="fill" [ngClass]="{'full-width': forSalesOrder == true}">
    <mat-label>City</mat-label>
    <input (keyup.enter)="onEnter()" matInput class="ta-customersearch-city" [(ngModel)]="customerRequest.city" data-hj-whitelist id="cityField">
    <button class="mat-mdc-button-transparentBackground-BlackColor" *ngIf="customerRequest.city" matSuffix mat-icon-button aria-label="Clear"
      (click)="customerRequest.city=''" style="color: black !important;">
      <mat-icon>close</mat-icon>
    </button>
    <mat-hint
      *ngIf=" (customerRequest.city == '' || customerRequest.city.length < 3) ">
      At least 3 characters</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="fill" [ngClass]="{'full-width': forSalesOrder == true}">
    <mat-label>Phone</mat-label>
    <input (keyup.enter)="onEnter()" matInput class="ta-customersearch-phone" [(ngModel)]="customerRequest.phoneNumber" data-hj-whitelist
      id="phoneField">
    <button class="mat-mdc-button-transparentBackground-BlackColor"  *ngIf="customerRequest.phoneNumber" matSuffix mat-icon-button aria-label="Clear"
      (click)="customerRequest.phoneNumber=''" style="color: black !important;">
      <mat-icon>close</mat-icon>
    </button>
    <mat-hint
      *ngIf="(customerRequest.phoneNumber == '' || customerRequest.phoneNumber.length < 4)">
      At least 4 characters</mat-hint>
  </mat-form-field>
</span>

<hr style="margin-top: 0px;" *ngIf="currentWidth >= 768 && !forSalesOrder">
<br>
<div align=" center">
  <!-- <div id="divSearch">
  <span id="leftSpace"></span> -->
  <button id="searchButton" mat-button 
    [disabled]="(customerRequest.nameId == '' || customerRequest.nameId.length < 3 )&&(customerRequest.name == '' || customerRequest.name.length < 3 ) && (customerRequest.city == '' || customerRequest.city.length < 3) && (customerRequest.phoneNumber == '' || customerRequest.phoneNumber.length < 4)"
    [ngClass]="'ta-customersearch-search pull-right text-white btn btn-sm btn-'+globals.colorTheme"
    (click)="searchCustomer()">Search</button>
</div>
<!-- 
      [ngClass]="forSalesOrder == true?'half-width ta-customersearch-search pull-right text-white btn btn-sm btn-'+globals.colorTheme: 'ta-customersearch-search pull-right text-white btn btn-sm btn-'+globals.colorTheme"

<mat-action-row *ngIf="currentWidth < 768">
  <button mat-button
    [disabled]="(customerRequest.name == '' || customerRequest.name.length < 3 ) && (customerRequest.city == '' || customerRequest.city.length < 3) && (customerRequest.phoneNumber == '' || customerRequest.phoneNumber.length < 4)"
    [ngClass]="'pull-right text-white btn btn-sm btn-'+globals.colorTheme" (click)="searchCustomer()">Search</button>
</mat-action-row> -->

<div (window:resize)="onResize($event)"></div>